module.exports = __webpack_public_path__ + "fonts/constellaDrps.cc165a1.eot";